var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "tit-wrap mb-0"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("상품권 구매하기")]), _c('div', {
    staticClass: "font-size-14 font-size-md-16 grey--text text--garken-3"
  }, [_vm._v(" PG 결제를 통해 나누리 캐시 교환권을 구매하실 수 있습니다. ")])]), _c('v-divider', {
    staticClass: "my-6 my-lg-12"
  }), _c('purchase-method', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.payment.method,
      callback: function callback($$v) {
        _vm.$set(_vm.form.payment, "method", $$v);
      },
      expression: "form.payment.method"
    }
  }), _c('v-divider', {
    staticClass: "my-6 my-lg-12"
  }), _c('purchase-amount', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _c('v-divider', {
    staticClass: "my-6 my-lg-12"
  }), _c('purchase-action', _vm._g(_vm._b({
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'purchase-action', {
    loading: _vm.loading
  }, false), {
    exit: _vm.exit,
    post: _vm.post
  }))], 1)])]), _c('common-loader', _vm._b({}, 'common-loader', {
    loading: _vm.loading
  }, false)), _c('kcp-cert', {
    ref: "kcpCert"
  }), _c('checkpay', {
    ref: "checkpay",
    on: {
      "complete": _vm.onCheckpayComplete,
      "close": function close($event) {
        _vm.loading = false;
      }
    }
  }), _c('popup-layer', {
    attrs: {
      "code": "nshop"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }